import * as types from './types';
import { allOption } from '../../helpers/constants';

const INITIAL_STATE = {
  errors: '',
  fetching: false,
  grades: [],
  releaseCategories: [],
  report: null,
  excelReport: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.MASTER_ROSTER_FETCH_ERROR:
      return { ...state, errors: payload };

    case types.MASTER_ROSTER_FETCHING:
      return { ...state, fetching: payload };

    case types.MASTER_ROSTER_GET_DATA:
      const grades = [
        allOption,
        ...payload.grades.map(grade => {
          return { text: grade.Id + ' ' + grade.Description, value: grade.Id };
        }),
      ];
      const releaseCategories = [
        allOption,
        ...payload.releaseCategories.map(cat => {
          return { text: cat.Description, value: cat.Id };
        }),
      ];
      return { ...state, grades, releaseCategories };

    case types.MASTER_ROSTER_GET_REPORT:
      return { ...state, report: payload };

    case types.MASTER_ROSTER_CLEAR_REPORT:
      return {
        ...state,
        report: this.INITIAL_STATE.report,
      };

    case types.MASTER_ROSTER_GET_EXCEL_REPORT:
      return { ...state, excelReport: action.payload };

    case types.MASTER_ROSTER_CLEAR_EXCEL_REPORT:
      return { ...state, excelReport: null };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/masterroster/state/masterroster/reducer.js